/**
 * Russian translations for Cyberpass Admin Panel
 */
const ru = {
  /* Common */
  "common.loading": "Загрузка...",
  "common.save": "Сохранить",
  "common.add": "Добавить",
  "common.archive": "Архивировать",
  "common.archiveItem": "Архивировать",
  "common.cancel": "Отмена",
  "common.retry": "Повторить",
  "common.confirm": "Подтвердить",
  "common.editRecord": "Редактирование записи",
  "common.noData": "Данные отсутствуют",
  "common.readOnly": "(нельзя редактировать)",
  "common.selectPlaceholder": "-- {label} --",
  "common.uploading": "Загрузка...",
  "common.replace": "Заменить",
  "common.upload": "Загрузить",
  "common.delete": "Удалить",
  "common.pasteFromClipboard": "или вставьте изображение из буфера обмена",
  "common.search": "Поиск",
  "common.back": "Назад",
  "common.byPhone": "По телефону",
  "common.byName": "По имени",
  "common.byEmail": "По E-mail",
  "common.notFound": "Не найден",
  "common.found": "Найден",
  "common.minutes": "мин",
  "common.hours": "ч",
  "common.openInEmployeePanel": "Открыть в панели сотрудника",
  "common.notSpecified": "Не указан",
  "common.addComputer": "Добавить компьютер",
  "common.yes": "Да",
  "common.no": "Нет",
  "common.close": "Закрыть",
  "common.or": "или",
  "common.all": "Все",
  "common.none": "Нет",

  /* Language */
  "language.ru": "Русский",
  "language.en": "English",
  "language.select": "Язык",

  /* Auth / Login */
  "auth.signIn": "Войти",
  "auth.login": "Логин",
  "auth.password": "Пароль",
  "auth.restorePassword": "Восстановить пароль",
  "auth.passwordRecovery": "Восстановление пароля",
  "auth.telegramUsername": "Имя пользователя в Telegram",
  "auth.loginSuccess": "Успешный вход в систему",
  "auth.loggingIn": "Вход",
  "auth.fetchUserFailed": "Не удалось получить данные о пользователе",
  "auth.incorrectCredentials": "Неверные логин или пароль",
  "auth.locationNotFound": "Указанная локация удалена или неактивна",
  "auth.unexpectedError": "Произошла непредвиденная ошибка",
  "auth.locationsError": "Не удалось получить список доступных локаций",
  "auth.passwordSent": "Новый пароль отправлен в Telegram",
  "auth.userNotFoundInTelegram":
    "Пользователь с таким Telegram username не найден",

  /* NavBar */
  "nav.registerUser": "Регистрация пользователя",
  "nav.interactWithUser": "Взаимодействие с пользователем",

  /* Admin Sidebar */
  "admin.employeePanel": "Панель сотрудника",
  "admin.managerPanel": "Панель менеджера",
  "admin.scanQr": "Сканировать\nQR-код",
  "admin.restoreAccess": "Восстановить доступ",
  "admin.recentCustomers": "Недавние клиенты",
  "admin.logout": "Выйти из системы",

  /* Super Admin Sidebar */
  "super.customers": "Клиенты",
  "super.employees": "Сотрудники",
  "super.packages": "Пакеты",
  "super.locations": "Локации",
  "super.services": "Услуги",
  "super.import": "Импорт",
  "super.calendar": "Календарь",
  "super.media": "Медиа",
  "super.discounts": "Скидки",
  "super.marketing": "Маркетинг",
  "super.playtime": "Компьютеры",

  /* QR Scanner */
  "qr.scan": "Сканировать QR-код",
  "qr.camera": "Камера",
  "qr.manualInput": "Вручную",
  "qr.placeholder": "QR код",
  "qr.userNotFound": "Пользователь не найден",
  "qr.userFound": "Пользователь найден",
  "qr.cameraUnavailable": "Камера недоступна",

  /* Restore Access */
  "restore.title": "Восстановить доступ",
  "restore.phoneLabel": "Номер телефона клиента",
  "restore.found": "Найден",
  "restore.notFound": "Не найден",
  "restore.name": "Имя",
  "restore.email": "Email",
  "restore.balance": "Баланс",
  "restore.balanceUnit": "мин.",
  "restore.enableEmailNotifications":
    "Включить отправку обновлений баланса на email",
  "restore.confirmWithNotifications": "Подтвердить и включить уведомления",
  "restore.confirm": "Подтвердить",
  "restore.modalTitle": "Восстановление доступа",
  "restore.modalBody":
    "На почту клиента {email} будет отправлено письмо с уведомлением о входе и резервным QR.",
  "restore.modalHint":
    "Если email не актуален, попросите клиента его обновить, повторно пройдя регистрацию.",
  "restore.success": "Доступ успешно восстановлен",
  "restore.error": "Ошибка при восстановлении доступа",

  /* Customer Info */
  "customer.phone": "Телефон",
  "customer.email": "E-mail",
  "customer.balance": "Баланс",
  "customer.debt": "Долг",
  "customer.minutes": "мин",
  "customer.hours": "ч",
  "customer.birthDate": "День рождения",
  "customer.vip": "VIP",
  "customer.basic": "Базовый",
  "customer.canBecomeVipToday": "может стать VIP сегодня!",
  "customer.lastVisit": "Последнее посещение",

  /* Customer History Tab */
  "history.date": "Дата",
  "history.employee": "Сотрудник",
  "history.location": "Локация",
  "history.minutes": "Минут",
  "history.amount": "Сумма",
  "history.service": "Услуга",
  "history.event": "Событие",

  /* Customer Tabs */
  "customerTab.buyMinutes": "Купить минуты",
  "customerTab.checkoutMinutes": "Списать минуты",
  "customerTab.history": "История",
  "customerTab.discounts": "Скидки",

  /* Page Titles */
  "page.customers": "Клиенты",
  "page.employees": "Сотрудники",
  "page.packages": "Пакеты минут",
  "page.locations": "Локации",
  "page.services": "Услуги",
  "page.allowedWallets": "Импортируемые абонементы",
  "page.holidays": "Календарь выходных дней",
  "page.media": "Медиа",
  "page.discounts": "Скидки",
  "page.marketing": "Маркетинг",
  "page.paperWallets": "Импортируемые абонементы",
  "page.restoreAccess": "Восстановить доступ",
  "page.playtime": "Компьютеры",
  "page.flexibleDiscounts": "Гибкие скидки",

  /* Holidays */
  "holidays.instruction":
    "Введите праздничные дни для каждого месяца (по одному на строку, формат ДД.ММ)",
  "holidays.format": "Формат",
  "holidays.clear": "Очистить",

  /* Page: Add/Edit dialogs */
  "dialog.add": "Добавить",
  "dialog.addEmployee": "Добавить сотрудника",
  "dialog.addPackage": "Добавить пакет минут",
  "dialog.addLocation": "Добавить локацию",
  "dialog.addService": "Добавить услугу",
  "dialog.addDiscount": "Добавить скидку",
  "dialog.addRecord": "Добавить",
  "dialog.editRecord": "Редактирование записи",
  "dialog.addHoliday": "Добавить",
  "dialog.addMedia": "Добавить",
  "dialog.addAllowedWallet": "Добавить",
  "dialog.addPaperWallet": "Добавить диапазон",
  "dialog.addZone": "Добавить зону",
  "dialog.addComputer": "Добавить компьютер",

  /* Table Columns */
  "col.id": "ID",
  "col.firstName": "Имя",
  "col.lastName": "Фамилия",
  "col.phone": "Телефон",
  "col.email": "E-mail",
  "col.birthDate": "День рождения",
  "col.minutesBalance": "Баланс минут",
  "col.debt": "Долг",
  "col.registeredAt": "Зарегистрирован",
  "col.username": "Логин",
  "col.telegram": "Telegram",
  "col.isActive": "Активен",
  "col.minutesAmount": "Количество минут",
  "col.onlineBonus": "Бонус онлайн",
  "col.cashBonus": "Бонус наличные",
  "col.vipBonus": "VIP бонус",
  "col.price": "Цена",
  "col.discount": "Скидка",
  "col.isInstant": "Мгновенный",
  "col.available": "Доступен",
  "col.name": "Название",
  "col.address": "Адрес",
  "col.isLocationActive": "Активна",
  "col.coverUrl": "Обложка",
  "col.easyweekUuid": "EasyWeek UUID",
  "col.bookingServices": "Услуги бронирования",
  "col.latitude": "Широта",
  "col.longitude": "Долгота",
  "col.appointmentMaxPlayers": "Макс. игроков (запись)",
  "col.serviceName": "Название услуги",
  "col.serviceActive": "Услуга активна",
  "col.seats": "Количество игровых мест",
  "col.location": "Локация",
  "col.from": "От",
  "col.to": "До",
  "col.year": "Год",
  "col.renderIndex": "Индекс",
  "col.description": "Описание",
  "col.dayType": "Тип дня",
  "col.filePath": "Путь к файлу",
  "col.locationId": "Локация",
  "col.marketingConsent": "Согласие на маркетинг",
  "col.comment": "Комментарий",
  "col.amount": "Размер",
  "col.zoneName": "Зона",
  "col.computerNumber": "Компьютер №",
  "col.apiKey": "API Key",
  "col.status": "Статус",
  "col.zoneId": "Зона",

  /* Form Labels */
  "form.marketingConsent": "Согласие на маркетинг",
  "form.comment": "Комментарий",
  "form.minutesAmount": "Количество минут",
  "form.price": "Цена",
  "form.discount": "Скидка",
  "form.isInstant": "Мгновенный",
  "form.available": "Доступен",
  "form.name": "Название",
  "form.address": "Адрес",
  "form.latitude": "Широта",
  "form.longitude": "Долгота",
  "form.coverUrl": "Обложка",
  "form.easyweekUuid": "EasyWeek UUID",
  "form.easyweekLocationUuid": "EasyWeek UUID локации",
  "form.easyweekServiceUuid": "EasyWeek UUID услуги",
  "form.bookingServices": "Услуги бронирования",
  "form.appointmentMaxPlayers": "Макс. игроков (запись)",
  "form.serviceName": "Название услуги",
  "form.location": "Локация",
  "form.seats": "Количество игровых мест",
  "form.active": "Активен",
  "form.from": "От",
  "form.to": "До",
  "form.year": "Год",
  "form.renderIndex": "Индекс",
  "form.description": "Описание",
  "form.dayType": "Тип дня",
  "form.filePath": "Путь к файлу",
  "form.locationId": "Локация",
  "form.firstName": "Имя",
  "form.lastName": "Фамилия",
  "form.phone": "Телефон",
  "form.email": "E-mail",
  "form.birthDate": "Дата рождения",
  "form.username": "Логин",
  "form.telegram": "Telegram",
  "form.zoneName": "Название зоны",
  "form.computerNumber": "Номер компьютера",
  "form.apiKey": "API Key",
  "form.zoneId": "Зона",
  "form.status": "Статус",

  /* Toast messages */
  "toast.recordUpdated": "Запись обновлена",
  "toast.recordCreated": "Запись добавлена",
  "toast.recordUpdateFailed": "Не удалось обновить запись",
  "toast.recordSaveFailed": "Не удалось сохранить запись",
  "toast.recordCreateFailed": "Не удалось добавить запись",
  "toast.employeeArchived": "Сотрудник архивирован",
  "toast.employeeArchiveFailed": "Не удалось архивировать сотрудника",
  "toast.packageArchived": "Пакет минут архивирован",
  "toast.packageArchiveFailed": "Не удалось архивировать пакет минут",
  "toast.locationArchived": "Локация архивирована",
  "toast.locationArchiveFailed": "Не удалось архивировать локацию",
  "toast.serviceArchived": "Услуга архивирована",
  "toast.serviceArchiveFailed": "Не удалось архивировать услугу",
  "toast.discountArchived": "Скидка архивирована",
  "toast.discountArchiveFailed": "Не удалось архивировать скидку",
  "toast.zoneCreated": "Зона создана",
  "toast.zoneUpdated": "Зона обновлена",
  "toast.zoneArchived": "Зона архивирована",
  "toast.zoneSaveFailed": "Не удалось сохранить зону",
  "toast.zoneArchiveFailed": "Не удалось архивировать зону",
  "toast.computerCreated": "Компьютер создан",
  "toast.computerUpdated": "Компьютер обновлен",
  "toast.computerArchived": "Компьютер архивирован",
  "toast.computerSaveFailed": "Не удалось сохранить компьютер",
  "toast.computerArchiveFailed": "Не удалось архивировать компьютер",
  "toast.apiKeyPrefilled": "API Key заполнен из QR-кода",
  "toast.apiKeyNotFound": "В QR-коде нет API Key компьютера",
  "toast.noZonesForComputer":
    "В этой локации нет зон. Пожалуйста, сначала добавьте зону.",
  "toast.selectLocationFirst": "Сначала выберите локацию",
  "toast.installExpired":
    "QR-код установки истёк. Запустите установку заново, чтобы получить новый ключ.",
  "toast.packageFetchFailed": "Не удалось получить список пакетов минут",
  "toast.customerDataRefreshFailed": "Не удалось обновить данные клиента",
  "toast.walletImported": "Бумажный кошелек успешно импортирован",
  "toast.walletImportFailed":
    "Верификация кошелька не удалась. Проверьте номер или он мог быть уже импортирован.",
  "toast.orderCancelled": "Заказ успешно отменен",
  "toast.orderCancelFailed": "Не удалось отменить заказ",
  "toast.cancellingOrder": "Отмена заказа",
  "toast.transactionIdNotFound": "Не удалось найти ID транзакции",
  "toast.fillAllFields": "Заполните все поля",
  "toast.categoryUpdated": "Категория обновлена",
  "toast.categoryCreated": "Категория добавлена",
  "toast.categoryDeleted": "Категория удалена",
  "toast.triggerUpdated": "Триггер обновлен",
  "toast.triggerCreated": "Триггер добавлен",
  "toast.triggerDeleted": "Триггер удален",
  "toast.enterTitle": "Введите заголовок",
  "toast.enterDescription": "Введите описание",
  "toast.enterBody": "Введите текст уведомления",
  "toast.selectCategory": "Выберите категорию получателей",
  "toast.notifScheduled": "Уведомление запланировано",
  "toast.selectTrigger": "Выберите триггер",
  "toast.notifTriggerCreated": "Уведомление создано по триггеру",
  "toast.notifDeleted": "Уведомление удалено",
  "toast.invalidPattern": "Неверный формат",
  "toast.daysExceedMonth": "Дни превышают границу месяца",

  /* Confirm Dialog */
  "confirm.archiveTitle": "Подтверждение архивирования",
  "confirm.deleteCardTitle": "Подтверждение удаления карты",
  "confirm.archiveMessage": "Вы уверены, что хотите архивировать {item}?",
  "confirm.deleteCardMessage":
    "Вы уверены, что хотите удалить карту passteam {item}?",
  "confirm.archiveWarning":
    "⚠️ Это действие нельзя отменить. Архивирование скроет элемент из активного списка.",
  "confirm.deleteCardWarning":
    "⚠️ Это действие нельзя отменить. Удаление карты приведет к ее полному удалению.",
  "confirm.archiveAction": "Архивировать",
  "confirm.deleteCardAction": "Удалить карту",

  /* Active Online Order */
  "order.paymentInProgress": "Оплата в процессе",
  "order.statusInfo": "Информация о статусе заказа",
  "order.confirmation": "Подтверждение",
  "order.payment": "Оплата",
  "order.success": "Успешно",
  "order.minutesAmount": "Количество минут",
  "order.cost": "Стоимость",
  "order.phoneNumber": "Номер телефона",
  "order.showQr": "Показать QR-код",
  "order.hideQr": "Скрыть QR-код",
  "order.cancelOrder": "Отменить заказ",
  "order.confirmCancel": "Заказ будет отменен",
  "order.cancelLoading": "Отмена заказа",

  /* Import Paper Wallet */
  "wallet.import": "Импорт",
  "wallet.importTitle": "Импорт кошелька",
  "wallet.walletNumber": "Номер бумажного кошелька",
  "wallet.balance": "Баланс, мин",
  "wallet.importAction": "Импортировать",

  /* Marketing */
  "marketing.allCustomers": "Все клиенты",
  "marketing.newCustomers": "Новые (до 30 дней)",
  "marketing.vipCustomers": "VIP (100+ баллов)",
  "marketing.afterPurchase": "После покупки",
  "marketing.birthday": "День рождения",
  "marketing.specialOffer": "Специальное предложение",

  /* History Context Menu */
  "history.cancelTransaction": "Отменить транзакцию",
  "history.cancelWarningPurchase":
    "‼️ Транзакция на покупку, отмена транзакции не инициирует возврат средств клиенту.\nПеред отменой ответственному менеджеру необходимо осуществить возврат в интерфейсе Paykeeper.",
  "history.cancelWarningPos":
    "‼️ Транзакция на покупку, отмена транзакции не инициирует отмену продажи по POS-системе.\nПеред отменой ответственному менеджеру необходимо организовать отмену в интерфейсе Fusion.",
  "history.cancelConfirm": "Отменить транзакцию",
  "history.cancelComment": "Комментарий (обязательно)",
  "history.cancelCommentPlaceholder": "Почему отменяем транзакцию?",
  "history.cancelCommentRequired": "Укажите комментарий к отмене",
  "history.cancelSuccess": "Транзакция успешно отменена",
  "history.cancelFailed": "Не удалось отменить транзакцию",

  /* Present Minutes */
  "present.giftMinutes": "Подарить минуты",
  "present.title": "Подарок минут",

  /* Markdown Editor */
  "markdown.editor": "Редактор",
  "markdown.preview": "Предпросмотр",
  "markdown.placeholder": "Текст в формате Markdown...",
  "markdown.noContent": "Нет содержимого",
  "markdown.previewTitle": "Заголовок",
  "campaign.previewNotifications": "Уведомления",

  /* Marketing Dashboard */
  "marketing.title": "Заголовок",
  "marketing.titlePlaceholder": "Специальное предложение",
  "marketing.description": "Описание",
  "marketing.descPlaceholder": "Краткое описание для списка уведомлений",
  "marketing.bodyLabel": "Текст уведомления (Markdown)",
  "marketing.schedule": "По расписанию",
  "marketing.trigger": "По триггеру",
  "marketing.category": "Категория получателей",
  "marketing.date": "Дата",
  "marketing.time": "Время",
  "marketing.repeat": "Повторение",
  "marketing.createNotif": "Создать уведомление",
  "marketing.scheduledNotifs": "Запланированные уведомления",
  "marketing.editCategory": "Редактировать категорию",
  "marketing.newCategory": "Новая категория",
  "marketing.name": "Название",
  "marketing.sqlQuery": "SQL-запрос",
  "marketing.deleteNotif": "Удалить уведомление",
  "marketing.confirmDeleteNotif": "Удалить уведомление «{title}»?",
  "marketing.editTrigger": "Редактировать триггер",
  "marketing.newTrigger": "Новый триггер",
  "marketing.triggerEnabled": "Триггер активен",
  "marketing.type": "Тип",
  "marketing.recipients": "Получатели",
  "marketing.status": "Статус",
  "marketing.newNotification": "Новое уведомление",

  "campaign.count": "Кампании ({count})",
  "campaign.create": "+ Создать",
  "campaign.name": "Название",
  "campaign.namePlaceholder": "Например: День рождения VIP",
  "campaign.nameRequired": "Введите название кампании",
  "campaign.nameRequiredHint":
    "Обязательно — по названию кампанию отличают в списке и в логе отправок.",
  "campaign.triggerType": "Тип триггера",
  "campaign.createBtn": "Создать кампанию",
  "campaign.createTitle": "Новая кампания",
  "campaign.createMenuCampaign": "Триггер, текст push, сегмент и расписание",
  "campaign.createMenuSegment": "Запрос к БД, задающий аудиторию для сегмента",
  "campaign.discardChanges":
    "В настройках кампании есть несохранённые изменения. Всё равно закрыть?",
  "campaign.editTitle": "Кампания: {name}",
  "campaign.editBtn": "Изменить",
  "campaign.segmentsBtn": "Сегменты",
  "campaign.segmentMenuTitle": "Новый сегмент",
  "campaign.scheduleRequired":
    "«{trigger}» запускается только по расписанию — задайте его в поле «Расписание (cron)». Без него кампания никогда не сработает.",
  "campaign.campaignFallback": "Кампания #{id}",
  "campaign.viewLog": "Лог",
  "campaign.close": "Закрыть",
  "campaign.log": "Лог отправок",
  "campaign.noCampaigns": "Кампаний пока нет. Нажмите «+ Создать».",
  "campaign.colStatus": "Статус",
  "campaign.colName": "Название",
  "campaign.colType": "Тип",
  "campaign.launch": "Запуск",
  "campaign.run": "Запуск",
  "campaign.test": "Тест",
  "campaign.delete": "Удалить кампанию",
  "campaign.selectTrigger": "Выберите тип триггера",
  "campaign.loadingFields": "Загрузка полей...",
  "campaign.noNotifications": "Уведомлений пока нет.",
  "campaign.colCustomer": "Клиент",
  "campaign.colPhone": "Телефон",
  "campaign.colSentAt": "Отправлено",
  "campaign.colVariant": "Вариант",
  "campaign.confirmDeleteTitle": "Удалить кампанию",
  "campaign.confirmDeleteMessage":
    "Удалить кампанию «{item}»? Также будут удалены лог отправок и снапшоты.",
  "campaign.toastCreated": "Кампания создана",
  "campaign.toastUpdated": "Кампания обновлена",
  "campaign.toastDeleted": "Кампания удалена",
  "campaign.toastRunResult": "Отправлено {sent} / {candidates} push",
  "campaign.toastTestResult": "Тестовый push отправлен {name}",
  "campaign.toastTestFailed": "Не удалось отправить тестовый push",
  "campaign.testDialogTitle": "Тест кампании",
  "campaign.testDialogDesc":
    "Отправить тестовый push клиенту по номеру телефона.",
  "campaign.testDialogPhone": "Номер телефона",
  "campaign.testDialogPhonePlaceholder": "+79001234567",
  "campaign.testDialogSend": "Отправить тест",
  "campaign.testDialogCancel": "Отмена",
  "campaign.testDialogNotFound": "Клиент не найден",
  "campaign.toastCreateFailed": "Не удалось создать кампанию",
  "campaign.toastUpdateFailed": "Не удалось обновить кампанию",
  "campaign.toastToggleFailed": "Не удалось переключить кампанию",
  "campaign.toastRunFailed": "Не удалось запустить кампанию",
  "campaign.toastRunSuccess": "Запуск кампании начат",
  "campaign.stats": "Статистика",
  "campaign.statCandidates": "Ближайший запуск (кандидаты)",
  "campaign.statSent": "Уже отправлено",
  "campaign.statFailed": "Ошибки",
  "campaign.toastDeleteFailed": "Не удалось удалить кампанию",
  "campaign.toastLogFailed": "Не удалось загрузить лог",
  "campaign.toastLoadFailed": "Не удалось загрузить кампании",
  "campaign.placeholders": "{плейсхолдеры}",
  "campaign.placeholdersAvailable": "Доступные плейсхолдеры:",
  "campaign.customSegments": "Свои сегменты",
  "campaign.segmentName": "Имя",
  "campaign.segmentQuery": "Запрос сегмента (SQL)",
  "campaign.segmentQueryHint":
    "Один SELECT, одна целочисленная колонка customer_id. Выполняется в режиме только чтения.",
  "campaign.segmentQueryRequired": "Сначала напишите запрос сегмента",
  "campaign.segmentPreview": "Проверить",
  "campaign.segmentPreviewing": "Проверяем…",
  "campaign.segmentPreviewFailed": "Не удалось проверить запрос",
  "campaign.segmentPreviewStale":
    "Запрос изменился — проверьте его снова, чтобы увидеть текущую аудиторию.",
  "campaign.segmentPreviewTotal": "Аудитория: {total} клиентов",
  "campaign.segmentPreviewUnknownTotal":
    "Показаны первые клиенты; полный подсчёт не уложился в лимит времени.",
  "campaign.segmentPreviewEmpty": "Запрос не находит ни одного клиента",
  "campaign.segmentPreviewName": "Имя",
  "campaign.segmentPreviewPhone": "Телефон",
  "campaign.segmentPreviewBalance": "Баланс",
  "campaign.segmentAdd": "Добавить сегмент",
  "campaign.segmentEdit": "Изменить",
  "campaign.segmentEditTitle": "Изменение сегмента",
  "campaign.segmentSave": "Сохранить запрос",
  "campaign.segmentCancelEdit": "Отменить изменение",
  "campaign.segmentUpdated": "Запрос сегмента обновлён",
  "campaign.segmentUpdateFailed": "Не удалось обновить сегмент",
  "campaign.segmentNameImmutable":
    "Имя менять нельзя: по нему кампании выбирают сегмент. Создайте новый сегмент и удалите старый.",
  "campaign.segmentUsedBy": "Используют кампании: {campaigns}",
  "campaign.segmentUnused": "Пока не используется ни одной кампанией",
  "campaign.segmentUsageIntro":
    "Сегмент — это запрос, который формирует аудиторию кампании. В списке ниже видно, какие кампании его выбирают: удаление или изменение запроса меняет аудиторию именно этих кампаний.",
  "campaign.segmentDelete": "Удалить сегмент",
  "campaign.segmentCreated": "Сегмент создан",
  "campaign.segmentDeleted": "Сегмент удалён",
  "campaign.segmentCreateFailed": "Не удалось создать сегмент",
  "campaign.segmentDeleteFailed": "Не удалось удалить сегмент",
  "campaign.segmentNameRequired": "Укажите имя сегмента",
  "campaign.noCustomSegments": "Своих сегментов пока нет",
  "campaign.segmentGlobal": "глобальный",
  "campaign.segmentScopeGlobal":
    "Сохраняется как глобальный сегмент — доступен всем кампаниям.",
  "campaign.segmentScopeCampaign": "Сохраняется только для этой кампании.",
  "campaign.segmentHelp": "Как работают свои сегменты",
  "campaign.segmentHelpIntro":
    "Свой сегмент — это запрос, который формирует его аудиторию. Он материализуется в snapshot вместе со встроенными сегментами, после чего доступен в поле «Имя сегмента в snapshot».",
  "campaign.segmentHelpContractTitle": "Контракт:",
  "campaign.segmentHelpContractNote":
    "Один SELECT (WITH ... SELECT тоже подходит), возвращающий ровно одну целочисленную колонку с именем customer_id. Всё, что пишет в базу, и вторая конструкция за ';' отклоняются; запрос всегда выполняется в транзакции только для чтения с ограничением по времени. Перед сохранением нажмите «Проверить» и посмотрите первые десять клиентов.",
  "campaign.copySql": "Копировать SQL",
  "campaign.sqlCopied": "SQL скопирован в буфер обмена",
  "campaign.copyingSql": "Копирование SQL…",
  "campaign.sqlCopyFailed": "Не удалось скопировать SQL",
  "campaign.copySendSql": "Копировать SQL отправки",
  "campaign.copySegmentSql": "Копировать запрос",
  "campaign.segmentSqlCopied": "Запрос сегмента скопирован",
  "campaign.segmentAllOption":
    "Все клиенты — с согласием на маркетинг и устройством",
  "campaign.abVariants": "Вариант B задаётся полями: {fields}",
  "campaign.abNothingToVary":
    "У этого триггера нечего варьировать — обе группы получат одинаковый текст",
  "campaign.insertDestination": "вставить ссылку",
  "campaign.destinationsAvailable": "Куда может вести ссылка:",
  "campaign.destinationHint":
    "Ссылка открывает выбранный экран приложения при нажатии в уведомлении. Сам push открывает это уведомление.",
  "campaign.destination.notifications": "Уведомления",
  "campaign.destination.booking": "Новая запись",
  "campaign.destination.appointments": "Мои записи",
  "campaign.destination.profile": "Профиль",
  "campaign.destination.vip": "VIP",
  "campaign.destination.vipTerms": "Условия VIP",
  "campaign.destination.contact": "Связаться с нами",
  "campaign.destination.transactions": "История операций",
  "campaign.closeHint": "Закрыть карточку кампании (Esc)",

  /* Управление запуском кампании */
  "campaign.runProgress": "Ход отправки",
  "campaign.stop": "Остановить",
  "campaign.stopping": "Остановка…",
  "campaign.toastRunStarted": "Запуск кампании начат",
  "campaign.toastStopRequested": "Остановка запрошена",
  "campaign.toastStopFailed": "Не удалось остановить кампанию",
  "campaign.runError": "Ошибка запуска: {error}",
  "campaign.runFailedHint":
    "Отправленным считается только тот push, который приняло устройство клиента.",
  "campaign.runState.running": "Отправка — доставлено {sent} из {total}",
  "campaign.runState.stopping":
    "Остановка запрошена — завершаем текущего клиента, доставлено {sent} из {total}",
  "campaign.runState.completed":
    "Завершено — доставлено {sent} из {total}, с ошибкой {failed}",
  "campaign.runState.stopped":
    "Остановлено — доставлено {sent} из {total}, с ошибкой {failed}",
  "campaign.runState.failed": "Запуск не удался — {by}",
  "campaign.runState.idle": "Простой",
  "campaign.runStateShort.running": "отправка…",
  "campaign.runStateShort.stopping": "остановка…",

  /* Лог отправок */
  "campaign.logRange": "{from}–{to} из {total}",
  "campaign.logPrev": "Новее",
  "campaign.logNext": "Старее",
  "campaign.holdoutTitle": "Холдаут: {pct}% не получают эту кампанию",
  "campaign.holdoutHint":
    "Эти клиенты исключены по id и не получат push этой кампании. Сравните их с логом отправок.",
  "campaign.holdoutEmpty": "В холдаут пока никто не попал",
  "campaign.holdoutShown": "Показаны {shown} из {total}",
  "campaign.colFailReason": "Причина",
  "campaign.logFailuresTitle": "Не доставлено: {count}",
  "campaign.logFailuresTruncated":
    "Показаны последние {shown} из {total} ошибок",
  "campaign.failureReason.noDevice": "нет push-токена устройства",
  "campaign.failureReason.disabled": "push-уведомления отключены",
  "campaign.failureReason.notDelivered": "не доставлено",
  "campaign.failureReason.sendFailed": "ошибка отправки",
  "campaign.failureReason.renderFailed": "ошибка шаблона",
  "campaign.failureReason.notRecorded": "отправлено, но не записано",

  /* Тестовая отправка */
  "campaign.toastTestNotDelivered":
    "Тестовый push для {name} не доставлен ни на одно устройство",

  /* Cron Picker */
  "cron.label": "Расписание (cron)",
  "cron.noSchedule": "Без расписания — только ручной запуск",
  "cron.preview": "Расписание",
  "cron.minute": "Мин",
  "cron.hour": "Час",
  "cron.day": "День",
  "cron.month": "Мес",
  "cron.weekday": "День нед",
  "cron.preset.disabled": "— Только ручной запуск",
  "cron.preset.daily10am": "Каждый день в 10:00",
  "cron.preset.daily9am": "Каждый день в 09:00",
  "cron.preset.weeklyMonday": "Каждый понедельник в 10:00",
  "cron.preset.monthly1st": "1-го числа каждого месяца в 10:00",
  "cron.preset.custom": "Произвольное расписание...",
  "cron.desc.manualOnly": "Только ручной запуск",
  "cron.desc.dailyAt": "Ежедневно в {time}",
  "cron.desc.weeklyAt": "Каждый {day} в {time}",
  "cron.desc.monthlyAt": "{day}-го числа каждого месяца в {time}",
  "cron.desc.dayOrWeekday":
    "День месяца ({dom}) ИЛИ день недели ({weekdays}) — cron выберет любой из них, а не оба сразу",
  "cron.desc.unsupported":
    "Cron не может описать это расписание пятью полями ({cron}). «2-й и 4-й вторник месяца» задаётся отдельным правилом, а не cron",
  "cron.desc.everyNMinutes": "Каждые {n} минут",
  "cron.desc.everyNHours": "Каждые {n} часов",
  "cron.weekdayNames.sun": "Вс",
  "cron.weekdayNames.mon": "Пн",
  "cron.weekdayNames.tue": "Вт",
  "cron.weekdayNames.wed": "Ср",
  "cron.weekdayNames.thu": "Чт",
  "cron.weekdayNames.fri": "Пт",
  "cron.weekdayNames.sat": "Сб",

  /* Repeat Labels */
  "repeat.once": "Один раз",
  "repeat.daily": "Ежедневно",
  "repeat.weekly": "Еженедельно",
  "repeat.monthly": "Ежемесячно",

  /* Status Labels */
  "status.scheduled": "Запланировано",
  "status.sent": "Отправлено",

  /* Common - additional */
  "common.open": "Открыть",
  "common.rename": "Переименовать",
  "common.import": "Импортировать",

  /* Table Row */
  "tableRow.package": "пакет минут",
  "tableRow.unknown": "неизвестно",
  "tableRow.cardOfCustomer": "карточку passteam клиента",
  "tableRow.element": "элемент",

  /* Confirm - additional */
  "confirm.deleteFile": "Удалить файл «{fileName}»?",
  "confirm.archiveMessagePrefix": "Вы уверены, что хотите",

  /* Checkout Minutes */
  "checkout.info": "Количество потраченных минут – доступен ввод любого числа",
  "checkout.confirmTitle": "Подтвердить списание минут",
  "checkout.willBeDeducted": "Будет снято",
  "checkout.customerWillHave": "У клиента останется",
  "checkout.service": "Сервис",
  "checkout.insufficientBalance1": "На балансе не хватает",
  "checkout.insufficientBalance2": "Открыть меню покупки пакетов со скидкам?",

  /* Payment Status */
  "payment.success": "Оплата прошла успешно",
  "payment.failure": "Упс, что-то пошло не так",
  "payment.minutesCredited":
    "Минуты зачислены на ваш баланс и доступны в приложениях",
  "payment.retry": "Пожалуйста повторите оплату",
  "payment.openInWallet": "Открыть в кошельке",

  /* Online Order Page */
  "orderPage.wrongRequest": "Wrong request",
  "orderPage.title": "Ваш заказ",
  "orderPage.instruction":
    "Проверьте пожалуйста информацию и перейдите к оплате",
  "orderPage.agreement":
    "Нажимая кнопку оплаты вы подтверждаете заказ и соглашаетесь c условиями сервиса",
  "orderPage.pay": "Оплатить",
  "orderPage.orderCancelled": "заказ отменён",
  "orderPage.payError":
    "Не удалось начать оплату. Возможно, заказ истек или был отменен.",
  "orderPage.orderExpired":
    "Срок действия заказа истек или он был отменен. Пожалуйста, обратитесь к сотруднику за новым заказом.",

  /* Media Display */
  "media.scanQr": "Отсканируйте QR-код",
  "media.toConfirmOrder": "для подтверждения заказа",
  "media.continueOnDevice": "Продолжите на своем устройстве",

  /* Registration */
  "registration.userExists":
    "Пользователь с таким номером телефона уже существует",
  "registration.firstname": "Имя",
  "registration.firstnamePlaceholder": "Иван",
  "registration.lastname": "Фамилия",
  "registration.lastnamePlaceholder": "Иванов",
  "registration.phone": "Телефон",
  "registration.telegram": "Имя пользователя в телеграм",
  "registration.confirmTitle": "Подтвердите регистрацию",

  /* Import Paper Wallet - buttons & labels */
  "importPaperWallet.button": "Импортировать абонемент",
  "importPaperWallet.title": "Импортировать абонемент",
  "importPaperWallet.walletNumber": "Номер бумажного абонемента",
  "importPaperWallet.balance": "Баланс, мин",
  "importPaperWallet.selectFile": "Выберите файл для импорта",
  "importPaperWallet.unknownError": "Неизвестная ошибка",
  "importPaperWallet.invalidFormat": "Неправильный формат",
  "importPaperWallet.tryAgain": "Попробуйте еще раз",

  /* Choose Package */
  "choosePackage.oneDiscountOnly": "Можно выбрать только один пакет со скидкой",
  "choosePackage.selectAtLeastOne": "Выберите как минимум один пакет минут",
  "choosePackage.calcFailed": "Не удалось рассчитать заказ",

  /* File Manager - additional */
  "fileManager.loadError": "Не удалось загрузить список файлов",
  "fileManager.manageFiles": "Управление файлами",
  "fileManager.showTable": "Показать таблицу",
  "fileManager.uploadSuccess": "Файл успешно загружен",
  "fileManager.uploadError": "Не удалось загрузить файл",
  "fileManager.deleteSuccess": "Файл удален",
  "fileManager.deleteError": "Не удалось удалить файл",
  "fileManager.renameSuccess": "Файл переименован",
  "fileManager.renameError": "Не удалось переименовать файл",
  "fileManager.filesUploaded": "Загружено файлов",
  "fileManager.uploadFilesError": "Не удалось загрузить файлы",

  /* Media Manager */
  "mediaManager.uploadTitle": "Загрузка файлов",
  "mediaManager.files": "Файлы",
  "mediaManager.noFiles": "Нет загруженных файлов",

  /* Toast - additional */
  "toast.selectService": "Выберите один из сервисов",
  "toast.debtCheckoutProhibited": "Невозможно списать минуты из-за долга",
  "toast.minutesDeducted": "Минуты успешно списаны",
  "toast.insufficientFunds": "Недостаточно средств",
  "toast.minutesDeductionFailed": "Не удалось списать минуты",
  "toast.servicesLoadError": "Ошибка загрузки услуг",
  "toast.minutesCredited": "Минуты успешно зачислены",
  "toast.minutesCreditFailed": "Не удалось зачислить минуты",
  "toast.orderCreated": "Заказ успешно создан",
  "toast.orderCreateFailed": "Не удалось создать заказ",
  "toast.debtCheckoutProhibited2":
    "Невозможно списать минуты, пока у клиента есть долг",
  "toast.paperWalletImported": "Бумажный абонемент успешно импортирован",
  "toast.paperWalletVerifyFailed":
    "Абонемент не прошёл проверку. Возможно ошибка в номере, или он уже был импортирован ранее.",
  "toast.connectionLost": "Потеряно соединение с сервером. Обновите страницу.",
  "toast.subscriptionFailed": "Не удалось подписаться на обновления",
  "toast.minutesPresented": "Минуты успешно подарены",
  "toast.enterPhoneOrSelectUser":
    "Введите номер телефона или выберите существующего пользователя",
  "toast.packagesLoadError":
    "Не удалось получить список пакетов минут от сервера",
  "toast.failedToUpdateCustomer": "Не удалось обновить данные клиента",

  /* Present Minutes */
  "presentMinutes.button": "Подарить минуты",
  "presentMinutes.title": "Подарить минуты",
  "presentMinutes.userFound": "Пользователь найден. Баланс",
  "presentMinutes.userNotFound": "Пользователя ещё нет в системе",
  "presentMinutes.packagesForGift": "Пакеты для подарка минут",
  "presentMinutes.confirmTitle": "Подтвердить подарок минут",
  "presentMinutes.willBeAdded": "Будет добавлено",
  "presentMinutes.for": "За",
  "presentMinutes.customerWillHave": "У клиента на счёте окажется",

  /* Common - general */
  "common.value": "значение",
  "common.until": "до",
  "common.vip": "VIP",
  "common.basic": "Базовый",
  "common.canBecomeVipToday": "может стать VIP сегодня!",

  /* Auth */
  "auth.incorrectLoginPassword": "Неверные логин или пароль",
  "auth.locationDeleted": "Указанная локация удалена или неактивна",

  /* Nav */
  "nav.restoreAccess": "Восстановить доступ",

  /* Buy Minutes */
  "buyMinutes.for": "За",
  "buyMinutes.expectedBalance": "У клиента на счёте окажется",
  "buyMinutes.availableBonuses": "Доступные бонусы за метод оплаты:",
  "buyMinutes.onlinePayment": "При оплате онлайн",
  "buyMinutes.cashPayment": "При оплате наличными",
  "buyMinutes.payCash": "Оплата наличными",
  "buyMinutes.payOnline": "Оплата онлайн",
  "buyMinutes.payPos": "Оплата POS",
  "buyMinutes.splitPaymentFusion": "Разделённая оплата Fusion",
  "buyMinutes.selectFusionMethod": "Выбрать метод оплаты Fusion",
  "buyMinutes.fusionInfoText":
    "При оплате заказа наличными или онлайн на прошлом этапе клиент получит бонусное время – обязательно проинформировать его об этом.",
  "buyMinutes.pay": "Оплатить",
  "buyMinutes.selectPaymentMethod": "Выберите способ оплаты",
  "buyMinutes.sumMismatch": "Сумма не сходится",
  "buyMinutes.of": "из",
  "buyMinutes.splitPayment": "Разделить оплату",

  /* Payment Types (Fusion POS) */
  "paymentType.cash": "Наличные",
  "paymentType.card": "Карта",
  "paymentType.sber": "Сбер",
  "paymentType.robokassa": "Робокасса",
  "paymentType.certificate": "Сертификат",
  "paymentType.bank_account": "Расчётный счёт",
  "paymentType.cyberpass_qr": "QR CyberPass",

  /* Buy Minutes */
  "buyMinutes.heading": "Пакеты для покупки минут",
  "buyMinutes.confirmTitle": "Подтверждение покупки",
  "buyMinutes.vipBonus": "VIP бонус",
  "buyMinutes.willBeAdded": "Будет добавлено",

  /* Flexible Discount */
  "flexibleDiscount.autoDiscount": "Автоматическая скидка",

  /* Transaction Review */
  "review.title": "Отмена транзакции #{id}",
  "review.type": "Тип транзакции",
  "review.location": "Локация",
  "review.admin": "Администратор",
  "review.customer": "Клиент",
  "review.phone": "Телефон",
  "review.minutes": "Минуты",
  "review.amount": "Стоимость",
  "review.balance": "Баланс",
  "review.debt": "долг",
  "review.managerComment": "Комментарий менеджера",
  "review.adminComment": "Комментарий администратора",
  "review.date": "Дата",
  "review.cancelTransaction": "Отменить транзакцию",
  "review.superUserOnly": "Отменять транзакции может только суперпользователь.",
  "review.confirmTitle": "Подтвердите отмену",
  "review.confirmMessage":
    "Вы уверены, что хотите отменить транзакцию? Это действие нельзя отменить.",
  "review.confirmAction": "Да, отменить",
  "review.cancelling": "Выполняется...",
  "review.locationMismatch":
    "Внимание: локация транзакции «{transactionLocation}» отличается от вашей текущей локации «{userLocation}».",
  "review.cancelled": "Транзакция отменена",
  "review.cancelError": "Ошибка отмены",
  "review.loadError": "Ошибка загрузки данных.",
  "review.networkError": "Ошибка сети.",
  "review.forbidden": "Доступ запрещён.",
  "review.notFound": "Транзакция не найдена.",
  "review.status.active": "Активна",
  "review.status.cancelled": "Отменена",

  /* Playtime */
  "playtime.zones": "Зоны",
  "playtime.computers": "Компьютеры",
  "playtime.zone": "Зона",
  "playtime.computer": "Компьютер",
  "computer.scanKey": "Сканировать API Key компьютера",
  "computer.closeScanner": "Закрыть",
  "computer.needNewZone": "Нужна новая зона, нажмите здесь",
  "computer.selectLocationHint":
    "Сначала выберите локацию, затем создайте зону",
  "computer.installExpiredWarning":
    "Этот QR-код установки истёк — 15-минутное окно прошло. Отсканируйте новый QR из свежей установки, чтобы сохранить этот компьютер.",
};

export default ru;
